import { sendRequest, sendRequestProtocols } from "../axios";
import { genSession } from "../service/session";
import { getDays } from "../service/getdays";
import Swal from "sweetalert2";

const generateDown = (item) => {
  const result = [];
  if (item.down_bank === 1) {
    result.push("Банк");
  }
  if (item.down_agent === 1) {
    result.push("Aгент");
  }
  if (item.down_bank_agent === 1) {
    result.push("Банк & Aгент");
  }
  return result.join(", ");
};

const generateUp = (item) => {
  const result = [];
  if (item.agentsupMin !== item.agentsupMax) {
    result.push(item.agentsupMin);
    result.push(" - ");
    result.push(item.agentsupMax);
    return result.join("");
  }

  return `${item.agentsupMax}`;
};

const generateType = (item) => {
  const result = [];
  if (item.what_fee === "range") {
    if (item.agentsFeeMin !== item.agentsFeeMax) {
      result.push("АВ ");
      result.push(item.agentsFeeMin);
      result.push(" - ");
      result.push(item.agentsFeeMax);
      return result.join("");
    }
    return `АВ ${item.agentsFeeMax}`;
  }
  if (item.what_fee === "netto") {
    if (item.nettoFee !== item.nettoFeeMax) {
      result.push("НЕТТО ");
      result.push(item.nettoFee);
      result.push(" - ");
      result.push(item.nettoFeeMax);
      return result.join("");
    }
    return `НЕТТО ${item.nettoFeeMax}`;
  }
};

export default {
  state: {
    calc: {
      msgDate: false,
      dogovor_subject: "",
      customer: "",
      customer_inn: "",
      customer_kpp: "",
      customer_adres: "",
      customer_ogrn: "",
      client_name: "",
      client_address: "",
      client_inn: "",
      client_kpp: "",
      client_ogrn: "",
      resultDialog: false,
      dialogBankView: false,
      dialogRateView: false,
      attentionDialog: false,
      bankViewData: [],
      rateViewData: [],
      winnerInfo: null,
      tz: null,
      smp: "",
      note: "",
      calcSession: "",
      dateConverted: "",
      dateConverted2: "",
      date: "",
      date2: "",
      date3: "",
      date4: "",
      date5: "",
      purchasesVal: 1,
      quaranteesVal: 1,
      gar_polz_zaksVal: null,
      your_situationsVal: null,
      lot: 1,
      decrision_of_price: "",
      purchase_number: "",
      nmkc: null, // number
      winprice: null, // number
      itogs: "",
      summ: null, // number
      trebUvelSumm: false,
      trebUvelSumm2: false,
      days: 0,
      isAvans: "Нет",
      isPaper: "Нет",
      isBS: "Да",
      isGarFormZak: "Нет",
      garFormZaksVal: "",
      message: "",
      srok_message: {
        color: "", // colorblue, colorred  only uses color
        message: "",
      },
    },
    banks: [],
    purchases: [],
    quarantees: [],
    vid: null,
    selected1: [],
    selected2: [],
    error_api: null,
    gar_polz_zaks: [],
    your_situations: [],
    podhoditItems: [],
    nepodhoditItems: [],
    calcCount: {
      to_date: null,
      count: null,
      api_key: null,
      api: 0,
    },
    protocolInfoShowed: false,
    calc_register_id: null,
    showFiltred: false, // показать в расчетах калькулятора фильтрованный объект
    filtredPodhoditItems: [],
  },
  mutations: {
    SET_SHOW_FILTRED(state, payload) {
      state.showFiltred = payload;
    },
    SET_FILTRED_PODHODIT_ITEMS(state, payload) {
      state.filtredPodhoditItems = payload;
    },
    setCalcRegisterId(state, payload) {
      state.calc_register_id = payload;
    },
    setProtocolInfoShowed(state, payload) {
      state.protocolInfoShowed = payload;
    },
    setBanks(state, payload) {
      state.banks = payload;
    },
    setCalcCount(state, payload) {
      state.calcCount = payload;
    },
    setCalcCountParam(state, payload) {
      state.calcCount[payload.param] = payload.value;
    },
    setCalcParam(state, paramData) {
      state.calc[paramData.param] = paramData.value;
    },
    setCalc(state, calcData) {
      state.calc = calcData;
    },
    setVID(state, payload) {
      state.vid = payload;
    },
    set_selected1(state, payload) {
      state.selected1 = payload;
    },
    set_selected2(state, payload) {
      state.selected2 = payload;
    },
    SET_SMP(state, commit) {
      state.calc.smp = commit;
    },

    SET_ERROR_API(state, commit) {
      state.error_api = commit;
    },
    SET_WINNER_TIME(state, commit) {
      state.calc.tz = commit;
    },
    SET_WINNER_INFO(state, commit) {
      state.calc.winnerInfo = commit;
    },

    SET_CLIENT_NAME(state, commit) {
      state.calc.client_name = commit;
    },
    SET_CLIENT_ADDRESS(state, commit) {
      state.calc.client_address = commit;
    },
    SET_CLIENT_INN(state, commit) {
      state.calc.client_inn = commit;
    },
    SET_CLIENT_KPP(state, commit) {
      state.calc.client_kpp = commit;
    },
    SET_CLIENT_OGRN(state, commit) {
      state.calc.client_ogrn = commit;
    },
    SET_DOGOVOR(state, commit) {
      state.calc.dogovor_subject = commit;
    },

    SET_CUSTOMER(state, commit) {
      state.calc.customer = commit;
    },
    SET_CUSTOMER_INN(state, commit) {
      state.calc.customer_inn = commit;
    },
    SET_CUSTOMER_KPP(state, commit) {
      state.calc.customer_kpp = commit;
    },
    SET_CUSTOMER_OGRN(state, commit) {
      state.calc.customer_ogrn = commit;
    },
    SET_CUSTOMER_ADRES(state, commit) {
      state.calc.customer_adres = commit;
    },

    SET_NMKC(state, commit) {
      state.calc.nmkc = commit;
    },
    SET_WINPRICE(state, commit) {
      state.calc.winprice = commit;
    },
    SET_BANK_DATA(state, commit) {
      state.calc.bankViewData = commit;
    },
    SET_RATE_DATA(state, commit) {
      state.calc.rateViewData = commit;
    },
    SET_ATTENTION_DIALOG(state, commit) {
      state.calc.attentionDialog = commit;
    },

    SET_BANK_VIEW_DIALOG(state, commit) {
      state.calc.dialogBankView = commit;
    },
    SET_RATE_VIEW_DIALOG(state, commit) {
      state.calc.dialogRateView = commit;
    },
    SET_CALC(state, commit) {
      state.calc = commit;
    },
    SET_RESULT_DIALOG(state, commit) {
      state.calc.resultDialog = commit;
    },
    SET_PODHODIT(state, commit) {
      state.podhoditItems = commit;
    },
    SET_NEPODHODIT(state, commit) {
      state.nepodhoditItems = commit;
    },
    SET_PURCHASES(state, payload) {
      state.purchases = payload;
    },
    SET_QUARANTEES(state, payload) {
      state.quarantees = payload;
    },
    SET_GAR_POLZ_ZAKS(state, payload) {
      state.gar_polz_zaks = payload;
    },
    SET_YOUR_SITUATIONS(state, payload) {
      state.your_situations = payload;
    },
  },
  actions: {
    SET_CALC_REGISTER_ID({ commit }, payload) {
      commit("setCalcRegisterId", payload);
    },
    async GET_CALC_REGISTER_BY_ID({ commit }, payload) {
      const { data } = await sendRequestProtocols(
        `calcregister/${payload}`,
        "get"
      );
      return data;
    },
    async GET_BANKS_LOGOS({ commit }) {
      const { data } = await sendRequest(`banks`, "get");
      commit("setBanks", data);
      return data;
    },
    async GET_CALC_COUNT({ commit }) {
      const { data } = await sendRequest(`firmCount`, "get");
      commit("setCalcCount", data);
      return data;
    },
    async GEN_API_KEY({ commit }) {
      const { data } = await sendRequest(`newApiKey`, "get");
      commit("setCalcCount", data);
      return data;
    },
    async GET_DAYS({ commit }, payload) {
      try {
        const { data } = await sendRequestProtocols(`getdays`, "post", {
          ...payload,
        });
        if (data) {
          commit("setCalcParam", { param: "days", value: data });
          return data;
        }
      } catch (e) {
        const days = getDays(payload.from, payload.to, true);
        if (days) {
          commit("setCalcParam", { param: "days", value: days });
          return days;
        }
        commit("setCalcParam", { param: "days", value: -1 });
      }
    },
    SET_CALC_PARAM({ commit }, data) {
      commit("setCalcParam", data);
    },
    SET_CALC({ commit }, data) {
      commit("setCalc", data);
    },
    GET_CALC_PARAM({ state }, param) {
      return state.calc[param];
    },
    async GET_SHORT_INFO({ state }, id) {
      const { data } = await sendRequest(`getShortInfo/${id}`, "get");
      return data;
    },
    async GET_TARIF_NOTE({ state }, id) {
      const { data } = await sendRequest(`getTarifNote/${id}`, "get");
      return data;
    },
    setNewCalculation({ commit }) {
      // калькуляция новая. чтоб стал новый расчет.
      const calc = {
        dogovor_subject: "",
        customer: "",
        customer_inn: "",
        customer_kpp: "",
        customer_adres: "",
        customer_ogrn: "",
        client_name: "",
        client_address: "",
        client_inn: "",
        client_kpp: "",
        client_ogrn: "",
        resultDialog: false,
        dialogBankView: false,
        dialogRateView: false,
        attentionDialog: false,
        bankViewData: [],
        rateViewData: [],
        winnerInfo: null,
        tz: null,
        smp: "",
        note: "",
        calcSession: "",
        dateConverted: "",
        dateConverted2: "",
        date: "",
        date2: "",
        date3: "",
        date4: "",
        date5: "",
        purchasesVal: 1,
        quaranteesVal: 1,
        gar_polz_zaksVal: null,
        your_situationsVal: null,
        lot: 1,
        decrision_of_price: "",
        purchase_number: "",
        nmkc: null, // number
        winprice: null, // number
        itogs: "",
        summ: null, // number
        trebUvelSumm: false,
        trebUvelSumm2: false,
        days: 0,
        isAvans: "Нет",
        isPaper: "Нет",
        isBS: "Да",
        isGarFormZak: "Нет",
        garFormZaksVal: "",
        message: "",
        srok_message: "",
      };
      commit("setCalc", calc);
    },
    SET_SELECTED1({ commit }, payload) {
      commit("set_selected1", payload);
    },
    SET_SELECTED2({ commit }, payload) {
      commit("set_selected2", payload);
    },
    showAdditional({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequestProtocols(`additional/${data}`, "post").then((response) => {
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    getWinnerTime({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequestProtocols(`getWinnerTime/${data}`, "post").then(
          (response) => {
            commit("SET_WINNER_TIME", response.data);
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    getWinnerinfo({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequestProtocols(`getWinnerinfo/${data}`, "post").then(
          (response) => {
            const WinnerInfo = {
              first_win: response.data.first_win,
              only_one: response.data.only_one,
            };

            commit("SET_WINNER_INFO", WinnerInfo);
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    clearResults({ commit }) {
      commit("SET_PODHODIT", []);
      commit("SET_NEPODHODIT", []);
      commit("set_selected1", []);
      commit("set_selected2", []);
      genSession();
    },
    getRateViewData({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        commit("SET_RATE_VIEW_DIALOG", false);
        sendRequest(`CalculatorBankAndProduct/${data}`, "get").then(
          (response) => {
            const editedItemProduct = response.data.rate;
            editedItemProduct.bank = response.data.bank.name;
            editedItemProduct.purchase = response.data.purchase;
            editedItemProduct.accreditation = response.data.accreditation;
            editedItemProduct.gar_polz_zak = response.data.gar_polz_zak;
            editedItemProduct.your_situation = response.data.your_situation;
            editedItemProduct.guarantee = response.data.guarantee;
            editedItemProduct.request = response.data.request;
            editedItemProduct.tariff = response.data.tariff;
            editedItemProduct.principal = response.data.principal;
            editedItemProduct.account = response.data.account;
            editedItemProduct.bail = response.data.bail;
            editedItemProduct.paper = response.data.paper;
            editedItemProduct.limit = response.data.limit;

            editedItemProduct.preview = response.data.preview;
            editedItemProduct.packet = response.data.packet;
            editedItemProduct.usn = response.data.usn;
            editedItemProduct.fns = response.data.fns;
            editedItemProduct.third = response.data.third;

            editedItemProduct.method = response.data.method;
            editedItemProduct.osob = response.data.osob;
            editedItemProduct.edo = response.data.edo;

            editedItemProduct.other = response.data.other;
            editedItemProduct.life = response.data.life;
            editedItemProduct.practice = response.data.practice;
            editedItemProduct.reloadbg = response.data.reloadbg;
            editedItemProduct.time = response.data.time;
            editedItemProduct.agentsfee = response.data.agentsfee;
            editedItemProduct.agentsup = response.data.agentsup;
            editedItemProduct.agentsdown = response.data.agentsdown;

            commit("SET_RATE_DATA", editedItemProduct);

            commit("SET_PROCESSING", false);

            resolve(response);
          }
        );
      });
    },
    getBankViewData({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        commit("SET_BANK_VIEW_DIALOG", false);
        sendRequest(`CalculatorBankAndProduct/${data}`, "get").then(
          (response) => {
            const bank = response.data.bank;
            bank.acra = response.data.acra;
            bank.raexpert = response.data.raexpert;
            bank.nkp = response.data.nkp;
            bank.nkp_note = response.data.nkp_note;
            bank.npa = response.data.npa;
            bank.npa_note = response.data.npa_note;
            bank.list = response.data.list;
            commit("SET_BANK_DATA", bank);
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    toggleBankViewWindow({ commit }, data) {
      commit("SET_BANK_DATA", null);
      commit("SET_BANK_VIEW_DIALOG", data);
    },
    toggleRateViewWindow({ commit }, data) {
      commit("SET_RATE_VIEW_DIALOG", data);
    },
    setResultDialog({ commit }, data) {
      commit("SET_RESULT_DIALOG", data);
    },
    setAttentionDIalog({ commit }, data) {
      commit("SET_ATTENTION_DIALOG", data);
    },

    DoCalc({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("doCalc", "post", data, reject).then((response) => {
          if (response.data.error) {
            if (response.data.error == "No Count today") {
              commit("SET_PROCESSING", false);
              Swal.fire({
                icon: "error",
                title: "Вам доступен 1 бесплатный расчет в сутки",
                html: `Чтобы получить безлимит и пользоваться калькулятором на специальных условиях, доступных только для участников закрытого клуба агентов, переходите в телеграмм-бота<br />
                    <a href='https://t.me/bankagent_bot?start=calc' target='_blank' >
                      <button type="button" class="swal2-confirm swal2-styled" aria-label="" style="text-decoration: none; display: inline-block; border-left-color: rgb(48, 133, 214); border-right-color: rgb(48, 133, 214); color: white;">
                        Перейти
                      </button>
                    </a>
                  `,
                // showCancelButton: true,
                // cancelButtonText: "Понятно",
                showConfirmButton: false,
              });
            }

            if (response.data.error) {
              if (
                response.data.error ==
                "Истек срок действия тарифа или количество расчетов"
              ) {
                commit("SET_PROCESSING", false);
                commit("setCalcParam", {
                  param: "date5",
                  value: "",
                });
                Swal.fire({
                  icon: "warning",
                  title: "Предупреждение!",
                  text: "Истек срок действия тарифа или количество расчетов",
                  showCloseButton: true,
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  // cancelButtonColor: "#d33",
                  confirmButtonText: "Оплатить доступ",
                  cancelButtonText: "Закрыть",
                  preConfirm: () => {
                    window.location.pathname = "/payment";
                  },
                });
                return;
              }
              commit("SET_PROCESSING", false);
              Swal.fire({
                icon: "error",
                title: "Ошибка",
                html: response.data.error,
                // showCancelButton: true,
                confirmButtonColor: "#3085d6",
                // cancelButtonText: "ОК",
                showConfirmButton: true,
                confirmButtonText: "ОК",
              });
            }
            resolve(response.data);
          } else {
            if (!response.data.register._id) {
              Swal.fire({
                icon: "warning",
                title: "Внимание",
                text: "Произошел сбой сохранения расчета",
              });
            }
            const podhoditItems = response.data.calcdata.podhodit.map(
              (item) => {
                const agentConditions = {
                  down: "",
                  down_desc: "",
                  up: "",
                  up_desc: "",
                  type: "",
                  type_desc: "",
                  sale: null,
                };
                // if(item.sale_now.length > 1){
                //   for(const sale of item.){
                //     if(sale.standart !== 1){
                //       agentConditions.type = generateType(sale)
                //       agentConditions.type_desc = sale.agentsfee_note
                //       agentConditions.down = generateDown(sale)
                //       agentConditions.down_desc = sale.down_description
                //       agentConditions.up = generateUp(sale)
                //       agentConditions.up_desc = sale.agentsup_note
                //       agentConditions.sale = sale
                //     }
                //   }
                // }else if(item.sale_now.length === 1){
                for (const sale of item.sale_now) {
                  agentConditions.type = generateType(sale);
                  agentConditions.type_desc = sale.agentsfee_note;
                  agentConditions.down = generateDown(sale);
                  agentConditions.down_desc = sale.down_description;
                  agentConditions.up = generateUp(sale);
                  agentConditions.up_desc = sale.agentsup_note;
                  agentConditions.sale = sale;
                }
                // }

                item.agentConditions = agentConditions;
                return item;
              }
            );
            const nepodhoditItems = response.data.calcdata.nePodhodit;
            commit("SET_PODHODIT", podhoditItems);

            //set data on filter
            const ups = [];
            const fees = [];
            for (const item of response.data.calcdata.podhodit) {
              if (item.sale_now.length) {
                for (const sale of item.sale_now) {
                  ups.push(sale.agentsupMin);
                  fees.push(sale.agentsFeeMax);
                }
              }
            }

            commit(
              "set_agentsFeeMinType",
              Array.from(new Set(fees))
                .filter((item) => item)
                .sort((a, b) => Number(a) - Number(b))
                .map((item, index) => ({
                  name: String(item),
                  selected: false,
                  id: index,
                }))
            );
            commit(
              "set_agentsupMinType",
              Array.from(new Set(ups))
                .filter((item) => item)
                .sort((a, b) => Number(a) - Number(b))
                .map((item, index) => ({
                  name: String(item),
                  selected: false,
                  id: index,
                }))
            );

            commit("SET_NEPODHODIT", nepodhoditItems);
            commit("setCalcCount", response.data.newcount);

            commit("SET_PROCESSING", false);
            resolve(response);
          }
        });
      });
    },

    getDataToForm({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("getDataToForm", "post", undefined, reject).then(
          (response) => {
            if (response.data.error == "Date is passed or Count is a 0") {
              commit("SET_PROCESSING", false);
              resolve(response.data);
            } else {
              commit("SET_PROCESSING", false);
              resolve(response);
            }
          }
        );
      });
    },

    SetLists({ commit }) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("getDataToCalc", "get").then((response) => {
          const purchases = response.data.purchase;
          const quarantees = response.data.quarantee;
          const gar_polz_zaks = response.data.gar_polz_zak;
          const your_situations = response.data.your_situation;

          commit("SET_PURCHASES", purchases);
          commit("SET_QUARANTEES", quarantees);
          commit("SET_GAR_POLZ_ZAKS", gar_polz_zaks);
          commit("SET_YOUR_SITUATIONS", your_situations);

          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
  },
  getters: {
    getCalcRegisterId: (store) => store.calc_register_id,
    calc: (store) => store.calc,
    getVID: (store) => store.vid,
    get_selected1: (store) => store.selected1,
    get_selected2: (store) => store.selected2,
    getGar_polz_zaks: (state) => state.gar_polz_zaks,
    getYour_situations: (state) => state.your_situations,
    getShowFiltred: (state) => state.showFiltred,
    getPodhodit: (state) => state.podhoditItems,
    getPodhodit1: (state) => {
      if (state.showFiltred && state.filtredPodhoditItems) {
        return state.filtredPodhoditItems.filter(
          (item) =>
            item.ikomsk !== 0 &&
            item.ikomsk !== "0" &&
            item.ikomsk !== "индивидуально"
        );
      } else {
        return state.podhoditItems.filter(
          (item) =>
            item.ikomsk !== 0 &&
            item.ikomsk !== "0" &&
            item.ikomsk !== "индивидуально"
        );
      }
    },
    getPodhodit2: (state) => {
      if (state.showFiltred && state.filtredPodhoditItems) {
        return state.filtredPodhoditItems.filter(
          (item) =>
            item.ikomsk === 0 &&
            item.ikomsk === "0" &&
            item.ikomsk === "индивидуально"
        );
      } else {
        return state.podhoditItems.filter(
          (item) =>
            item.ikomsk === 0 ||
            item.ikomsk === "0" ||
            item.ikomsk === "индивидуально"
        );
      }
    },
    getNePodhodit: (state) => state.nepodhoditItems,
    getPurchases: (state) => state.purchases,
    getPurchaseById: (state) => (id) => {
      return state.purchases.filter((item) => item.id === id);
    },
    getQuarantees: (state) => state.quarantees,
    getQuaranteesById: (state) => (id) => {
      return state.quarantees.filter((item) => item.id === id);
    },

    getResultDialog: (state) => state.calc.resultDialog,
    getDialogBankView: (state) => state.calc.dialogBankView,
    getDialogRateView: (state) => state.calc.dialogRateView,
    getbankViewData: (state) => state.calc.bankViewData,
    getrateViewData: (state) => state.calc.rateViewData,
    getAttentionDialog: (state) => state.calc.attentionDialog,
    getDogovor: (state) => state.calc.dogovor_subject,
    getNMKC: (state) => state.calc.nmkc,
    getWinprice: (state) => state.calc.winprice,
    getClientName: (state) => state.calc.client_name,
    getClientAddress: (state) => state.calc.client_address,
    getClientInn: (state) => state.calc.client_inn,
    getClientKPP: (state) => state.calc.client_kpp,
    getClientOGRN: (state) => state.calc.client_ogrn,
    getWinnerinfo: (state) => state.calc.winnerInfo,
    getWinnerTime: (state) => state.calc.tz,
    getCustomer: (state) => state.calc.customer,
    getCustomerInn: (state) => state.calc.customer_inn,
    getCustomerKpp: (state) => state.calc.customer_kpp,
    getCustomerOgrn: (state) => state.calc.customer_ogrn,
    getCustomerAdres: (state) => state.calc.customer_adres,
    getErrorApi: (state) => state.error_api,
    getSMP: (state) => state.calc.smp,
    getCalcCount: (state) => state.calcCount,
    getBanksLogos: (state) => state.banks,
    getProtocolInfoShowed: (state) => state.protocolInfoShowed,
  },
};
